import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Artists from "./pages/Artists";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import './index.css';

function App() {
  const [darkTheme, setDarkTheme] = useState(true);

  return (
    <Router>
      <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
        <Navbar darkTheme={darkTheme} setDarkTheme={setDarkTheme} />
        <main style={{ flex: 1 }}>
          <Routes>
            <Route path="/" element={<Home darkTheme={darkTheme} />} />
            <Route path="/about" element={<About darkTheme={darkTheme} />} />
            <Route path="/artists" element={<Artists darkTheme={darkTheme} />} />
            <Route path="/services" element={<Services darkTheme={darkTheme} />} />
            <Route path="/contact" element={<Contact darkTheme={darkTheme} />} />
          </Routes>
        </main>
        <Footer darkTheme={darkTheme} />
      </div>
    </Router>
  );
}

export default App;